export default "__VITE_ASSET__CRZm0z4Y__"